<p class="m-2">{{'patient-creation-overview.create_patient_description' | translate}}</p>
<button [attr.id]="'btnOpenDialogPatientAccountCreate'" (click)="openDialogPatientAccountCreate()" mat-button color="primary">
  <fa-icon [icon]="faUserPlus"></fa-icon> {{'patient-creation-overview.create_patient' | translate}}
</button>
